<template>
    <div class="row my-3">
        <div class="col-4 offset-md-3 col-md-3">
            <div class="d-flex justify-content-end">
                <label class="mb-0 mr-3  d-flex align-items-center justify-content-end"
                    >From:</label
                >
                <div class="mr-3 d-flex align-items-center justify-content-end">
                    <v-date-picker
                        class="form-control form-control-sm"
                        popover-align="right"
                        v-model="payload.start_at"
                    ></v-date-picker>
                </div>
            </div>
        </div>
        <div class="col-4 col-md-3">
            <div class="d-flex justify-content-end">
                <label class="mx-3 mb-0 d-flex align-items-center justify-content-end">to:</label>
                <div class="mr-3 d-flex align-items-center justify-content-end">
                    <v-date-picker
                        class="form-control form-control-sm"
                        popover-align="right"
                        v-model="payload.end_at"
                    ></v-date-picker>
                </div>
            </div>
        </div>
        <div class="col-4 col-md-3 d-flex justify-content-end">
            <button class="btn btn-sm btn-primary font-weight-bold" @click="generateReceipt()">
                Create Patient Receipt
            </button>
        </div>

        <errors :errors="errors"></errors>

        <patient-receipt
            ref="patientReceipt"
            :organization="organization"
            :payload="payload"
        ></patient-receipt>
    </div>
</template>

<script>
import PatientReceipt from "./PatientReceipt";
import { errors } from "../../plugins/errors";

export default {
    name: "PatientCreateReceipt",
    props: ["id", "organization"],
    mixins: [errors],
    components: {
        PatientReceipt,
    },
    data() {
        return {
            payload: this.generatePayload(),
        };
    },
    methods: {
        generatePayload() {
            return {
                start_at: new Date(),
                end_at: new Date(),
            };
        },
        generateReceipt() {
            const payload = {
                start_at: this.moment(this.payload.start_at).format("YYYY-MM-DD"),
                end_at: this.moment(this.payload.end_at).format("YYYY-MM-DD"),
            };
            let query = "?";
            Object.keys(payload).forEach(key => {
                if (payload[key]) {
                    let val = payload[key];
                    if (key.includes("_at")) {
                        val = this.moment(val).format("YYYY-MM-DD");
                    }
                    query += `${key}=${val}&`;
                }
            });
            axios
                .get(`/api/patients/${this.id}/receipts${query}`)
                .then(response => {
                    this.$refs.patientReceipt.receipt = response.data;
                    this.$refs.patientReceipt.isVisible = true;
                })
                .catch(e => {
                    this.setErrors(_.get(e, "response.data.errors", {}));
                });
        },
    },
};
</script>

<style scoped></style>
